import type { Policy } from '@cartwhl/common/appletPolicy';

import { withProvider } from './adminAssetUploadStore';
import AdminAssetUpload from './components/AdminAssetUpload';

const AdminAssetUploadWithStore = withProvider(AdminAssetUpload);

const applet = {
  id: 'admin-asset-upload',
  path: '/admin-asset-upload',
  paths: ['/admin-asset-upload'],
  label: 'Admin Asset Upload',
  description: 'Upload images and videos for blog and website.',
  dashboard: {
    title: 'Admin Asset Upload',
    description: 'Upload images and videos for blog and website.',
    order: 80,
  },
  policy: {
    requiresLoggedIn: true,
    requiresAdmin: true,
  } satisfies Policy,
  component: AdminAssetUploadWithStore,
};

export default applet;
